import { PayrollTypes } from "core/types/enums/WorkOrderEnum";

/**
 * Two different things read as "shop" to a user, so they are named apart:
 *
 * - Shop Labor — a time-range expense logged against a sub work order
 *   (wire value `Shop`).
 * - Shop Time — the standalone clock-in/out timer that belongs to no work
 *   order (wire value `ClockInOut`).
 *
 * `PayrollTypes` already holds the user-facing wording for every time type,
 * so these alias it rather than repeating the strings.
 */
export const SHOP_LABOR_LABEL: string = PayrollTypes.Shop;

export const SHOP_TIME_LABEL: string = PayrollTypes.Office;

/** Shown for an expense that carries no catalogue item, only a free-typed price and qty. */
export const MISCELLANEOUS_LABEL = "Miscellaneous";
